import { render } from "./PagesDropdown.vue?vue&type=template&id=f377cdf0"
import script from "./PagesDropdown.vue?vue&type=script&lang=js"
export * from "./PagesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dropdowns/PagesDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f377cdf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f377cdf0', __exports__)) {
    api.reload('f377cdf0', __exports__)
  }
  
  module.hot.accept("./PagesDropdown.vue?vue&type=template&id=f377cdf0", () => {
    api.rerender('f377cdf0', render)
  })

}


export default __exports__